module.exports = __webpack_public_path__ + "static/media/striped_end_bar.0fe2acfd.svg";